export const numberError="Please enter a valid numeric value."
export const percentageError="Please enter a numeric value between 0 to 100."
export const twoFieldError="Please fill both the fields.";
export const textError="This field is required."
export const listError="Please select atleast one option from the list.";
export const unitError="Please select unit"
